export default {
  id: null,
  despesaID: null,
  despesaTipoID: null,
  obraID: null,
  dataDespesa: null,
  quantidade: null,
  valorUnitario: null,
  observacao: null,
  cidadeOrigemID: null,
  cidadeDestinoID: null,
  cidadeOrigem: null,
  cidadeDestino: null,
  km: 0,
  dataInicioVoo: null,
  dataFimVoo: null,
  tipoPassagemVoo: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/expenseitemmodel.js